export const GET_ALL_LOGS = 'GET_ALL_LOGS';
export const GET_LOGS_BY_ID = 'GET_LOGS_BY_ID';
export const UPDATE_CURRENT_ACTIVITY_LOG = 'UPDATE_CURRENT_ACTIVITY_LOG';